var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappRefer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 49,
    rx: 3.5,
    fill: "#F7F7FC",
    stroke: "#D9DBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 35.25C31.799 35.25 36.5 30.549 36.5 24.75C36.5 18.951 31.799 14.25 26 14.25C20.201 14.25 15.5 18.951 15.5 24.75C15.5 26.6332 15.9957 28.4005 16.8639 29.9287L15.5 35.25L20.9861 33.9778C22.476 34.7891 24.1842 35.25 26 35.25ZM26 33.6346C30.9068 33.6346 34.8846 29.6568 34.8846 24.75C34.8846 19.8432 30.9068 15.8654 26 15.8654C21.0932 15.8654 17.1154 19.8432 17.1154 24.75C17.1154 26.6445 17.7084 28.4006 18.7189 29.8427L17.9231 32.8269L20.9599 32.0677C22.392 33.0559 24.1284 33.6346 26 33.6346Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24C35 28.9706 30.9706 33 26 33C24.1041 33 22.3452 32.4138 20.8945 31.4127L17.8182 32.1818L18.6243 29.1588C17.6007 27.698 17 25.9192 17 24C17 19.0294 21.0294 15 26 15C30.9706 15 35 19.0294 35 24Z",
    fill: "url(#paint0_linear_8075_67953)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 34.5C31.799 34.5 36.5 29.799 36.5 24C36.5 18.201 31.799 13.5 26 13.5C20.201 13.5 15.5 18.201 15.5 24C15.5 25.8832 15.9957 27.6505 16.8639 29.1787L15.5 34.5L20.9861 33.2278C22.476 34.0391 24.1842 34.5 26 34.5ZM26 32.8846C30.9068 32.8846 34.8846 28.9068 34.8846 24C34.8846 19.0932 30.9068 15.1154 26 15.1154C21.0932 15.1154 17.1154 19.0932 17.1154 24C17.1154 25.8945 17.7084 27.6506 18.7189 29.0927L17.9231 32.0769L20.9599 31.3177C22.392 32.3059 24.1284 32.8846 26 32.8846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 19.126C23.1254 18.6246 22.7424 18.669 22.3555 18.669C21.6641 18.669 20.5859 19.4972 20.5859 21.0386C20.5859 22.3018 21.1426 23.6846 23.0183 25.7532C24.8285 27.7495 27.207 28.7822 29.1817 28.7471C31.1563 28.7119 31.5625 27.0127 31.5625 26.4388C31.5625 26.1845 31.4047 26.0576 31.296 26.0231C30.6231 25.7002 29.382 25.0985 29.0996 24.9854C28.8172 24.8723 28.6698 25.0253 28.5781 25.1084C28.3221 25.3525 27.8144 26.0717 27.6406 26.2334C27.4668 26.3952 27.2077 26.3133 27.0999 26.2522C26.7031 26.093 25.6272 25.6144 24.7696 24.7831C23.709 23.7549 23.6467 23.4012 23.4469 23.0863C23.2871 22.8344 23.4044 22.6799 23.4629 22.6123C23.6914 22.3487 24.007 21.9416 24.1485 21.7393C24.29 21.537 24.1776 21.2299 24.1102 21.0386C23.8203 20.2159 23.5747 19.5272 23.375 19.126Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8075_67953",
    x1: 33.875,
    y1: 17.25,
    x2: 17,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappRefer);
export default __webpack_public_path__ + "static/media/whatsapp-refer.70314cb0.svg";
export { ForwardRef as ReactComponent };